import PostCalculator from './post-calculator';

export default class TwitterPostCalculator extends PostCalculator {

  hasImage;
  imageCount;

  constructor($target, $counter) {
    super($target, $counter);

    this.type = 'twitter';
    this.limit = 280;
  }

  calculate(update_display = true) {
    // Get the post
    var text = this.$target.val(),

        // Grab the length of the post
        length = text.length,

        // Get our limit ready
        count = this.limit,

        // Regex to look for links
        expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,7}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi,
        regex = new RegExp(expression),

        // Array of links in the post
        links = text.match(regex),

        adjustment,

        postbox = this.$target.closest('.postbox');

        // Did we find any links?
        if (!! links) {

          // Add Twitter's link length
          length += (23 * links.length);

          // Check each link and remove their length from the count
          for (var i = links.length - 1; i >= 0; i--) {
            // Adjust for http://t.co/ vs https://t.co/
            adjustment = (links[i].match('https')) ? -1 : 0;
            length -= (links[i].length + adjustment);
          }
        }

    // Calculate the length
    count -= length;

    // Update the display
    if (update_display) {
      this.update_display(count);
    }

    return count;
  }
}
